// extracted by mini-css-extract-plugin
export var body = "index-module--body--24cf1";
export var bound = "index-module--bound--e415b";
export var boxSection = "index-module--boxSection--a19b6";
export var boxSectionWrap = "index-module--boxSectionWrap--b56e4";
export var boxSection_body = "index-module--boxSection_body--3af9b";
export var boxSection_contents = "index-module--boxSection_contents--fc34c";
export var boxSection_image = "index-module--boxSection_image--aa44a";
export var boxSection_inner = "index-module--boxSection_inner--8f03b";
export var boxSection_text = "index-module--boxSection_text--7bf1e";
export var br_pc = "index-module--br_pc--e045e";
export var button_scroll = "index-module--button_scroll--f04b9";
export var casestudy = "index-module--casestudy--e2217";
export var en = "index-module--en--c47db";
export var image = "index-module--image--99358";
export var imageInner = "index-module--imageInner--2daa3";
export var image_wrap = "index-module--image_wrap--f003a";
export var ja = "index-module--ja--f9d86";
export var kv = "index-module--kv--f5a3f";
export var kv_bg = "index-module--kv_bg--c539d";
export var kv_title = "index-module--kv_title--bfe46";
export var lead = "index-module--lead--2b696";
export var line = "index-module--line--b26f5";
export var method = "index-module--method--3c163";
export var method_label = "index-module--method_label--fa4ab";
export var method_title = "index-module--method_title--a42b9";
export var more = "index-module--more--165a9";
export var section_header = "index-module--section_header--b8f39";
export var section_title = "index-module--section_title--1a763";
export var service = "index-module--service--3ed8b";
export var service_header = "index-module--service_header--06c82";
export var service_lead = "index-module--service_lead--1572e";
export var service_title = "index-module--service_title--84ccf";
export var show = "index-module--show--dc3f9";
export var state = "index-module--state--d5646";
export var state_bg = "index-module--state_bg--af797";
export var state_body = "index-module--state_body--f333f";
export var state_image1 = "index-module--state_image1--90194";
export var state_image2 = "index-module--state_image2--52d06";
export var state_inner = "index-module--state_inner--0b5db";
export var state_label = "index-module--state_label--3b0fe";
export var state_text = "index-module--state_text--195e1";
export var state_title = "index-module--state_title--d644f";
export var subpage_header = "index-module--subpage_header--94e93";
export var technology = "index-module--technology--4096f";
export var technology_label = "index-module--technology_label--630dd";
export var technology_title = "index-module--technology_title--1d163";
export var text = "index-module--text--92e65";